import {Button, InlineLoading, MenuButton, MenuItem} from '@carbon/react';
import {Download} from '@carbon/icons-react';

export interface IExportProps {
    isExporting: boolean;
    menuItems: Array<{ disabled: boolean; label: string; onClick: () => void }>;
}

const Export = (props: IExportProps) => {
    const {
        isExporting,
        menuItems
    } = props;

    // Get label for loading state (use first menu item's label for single item, "Exporting…" for multiple)
    const buttonLabel = menuItems.length === 1 ? (menuItems[0].label || 'Export') : 'Exporting…';

    if (isExporting) {
        return (
            <Button
                className='export-button'
                renderIcon={InlineLoading}
                disabled={Boolean(isExporting)}
                kind="primary"
                data-testid="reports-export-button"
            >
                {buttonLabel}
            </Button>
        );
    }

    // If there's only one menu item, render a simple button instead of dropdown
    if (menuItems.length === 1) {
        const {label, onClick, disabled} = menuItems[0];
        return (
            <Button
                className='export-button'
                renderIcon={Download}
                disabled={disabled}
                onClick={onClick}
                kind="primary"
                data-testid="reports-export-button"
            >
                {label || 'Export'}
            </Button>
        );
    }

    return (
        <MenuButton
            label="Export"
            menuAlignment="bottom-start"
            className="justify-between items-center"
            kind="primary"
            data-testid="reports-export-button"
        >
            {menuItems.map(menuItem => {
                const {label, onClick, disabled} = menuItem;
                return (
                    <MenuItem
                        key={label}
                        label={label}
                        onClick={onClick}
                        renderIcon={Download}
                        disabled={disabled}
                    />
                );
            })}
        </MenuButton>
    );
};

export default Export;
